import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/screeningassignments/types');

export function updateWeights(payload) {
	return http.put('/admin/screeningassignments/types/weights', payload).then(resp => resp.data);
}
